<div class="chip-root">
  <div class="chip"
       matRipple
       appThrottleClick
       [ngClass]="{
              small,
              gray,
              red,
              filled,
              green,
              orange,
              yellow,
              active,
              'gray-blue': grayBlue,
              'active-gray-blue': activeGrayBlue,
              'dark-blue': darkBlue,
              'default-cursor': defaultCursor,
              'filter': filter,
              'lightgray': lightgray
              }"
       (throttleClick)="emitClick()"
       [throttleTime]="1000">
    <mat-icon *ngIf="icon">{{icon}}</mat-icon>
    <ng-content></ng-content>
    <mat-icon *ngIf="iconAfter">{{iconAfter}}</mat-icon>
  </div>
  <div class="options-area-wrapper" *ngIf="options && showOptions" [@fadeInOut]>
    <div class="options-area">
      <div *ngFor="let option of options">
        <div id="lnr-option-{{option.key}}" class="options-item" (click)="emitClickOption(option)">{{option.text}}</div>
      </div>
    </div>
  </div>
</div>
